import React from 'react';
import {Link} from 'react-router-dom';
function game() {
    return (
        <div>
                <div component="p" style={{display: 'flex', justifyContent: 'center', 
                                            color: '#e0515d', marginTop: '25px', marginBottom: '20px',
                                            fontSize: '40px', fontFamily: 'balthazar,serif'}}>
                    GAMES...
                </div>
                <div style={{width: '33%'}}>
                </div>
                <div component="p" style={{display: 'flex', color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem', justifyContent: 'center',
                                            fontWeight: '400', width: '34%', left: '33%',
                                            textAlign: 'center', position: 'relative',
                                            marginBottom: '25px' 
                                            }}>
                    Quick answers to all of your burning questions. Play these cool, addictive games today!
                </div>
                <div style={{width: '33%'}}>
                </div>
            <div style={{backgroundColor: 'transparent', display: 'table',
                        width: '100%', tableLayout: 'fixed'}}>
                <div style={{width: '33%',display: 'table-cell', color: '#fefefe',
                              fontFamily: 'balthazar,serif',
                              fontSize: '1.8rem', justifyContent: 'center',
                              fontWeight: '400',  
                              textAlign: 'center', position: 'relative' 
                            }}>
                    <div><h1><p style={{color: '#e0515d', marginTop: '25px', height: '150px'}}>
                        <button>MAGIC LOVE BALL</button>
                        </p></h1>
                    </div>
                </div>
                <div component="p" style={{display: 'table-cell', color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem', justifyContent: 'center',
                                            fontWeight: '400', width: '33%', 
                                            textAlign: 'center', position: 'relative' 
                                            }}>

                    <div><h1> <p style={{marginTop: '25px', 
                                height: '150px', color: '#e0515d'}}>
                                    <button>SECRET CRUSH</button>
                                    </p>
                    </h1>
                    </div>
                </div>
                <div style={{width: 'auto%', display: 'table-cell', color: '#fefefe',
                              fontFamily: 'balthazar,serif',
                              fontSize: '1.8rem', justifyContent: 'center',
                              fontWeight: '400', 
                              textAlign: 'center', position: 'relative' }}>
                    <div>              
                        <h1><p style={{color: '#e0515d', marginTop: '25px', height: '150px'}}>
                            <button>ASK THE GENIE</button>
                            </p></h1>
                    </div>
                </div>
            </div>
            <div style={{backgroundColor: 'transparent', display: 'table',
                        width: '100%', tableLayout: 'fixed'}}>
                <div style={{width: '33%',display: 'table-cell', color: '#fefefe',
                              fontFamily: 'balthazar,serif',
                              fontSize: '1.8rem', justifyContent: 'center',
                              fontWeight: '400',  
                              textAlign: 'center', position: 'relative' 
                            }}>
                    <div><h1><p style={{color: '#e0515d', height: '150px'}}>
                        <Link to="/fortuneCookie"><button>FORTUNE COOKIE</button></Link>
                        </p></h1>
                    </div>
                </div>
                <div component="p" style={{display: 'table-cell', color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem', justifyContent: 'center',
                                            fontWeight: '400', width: '33%', 
                                            textAlign: 'center', position: 'relative' 
                                            }}>

                    <div><h1> <p style={{display:'flex', justifyContent:'center', 
                                        height: '150px', color: '#e0515d'}}>
                                            <button>BOOK OF LOVE</button>
                                            </p>
                    </h1>
                    </div>
                </div>
                <div style={{width: 'auto%', display: 'table-cell', color: '#fefefe',
                              fontFamily: 'balthazar,serif',
                              fontSize: '1.8rem', justifyContent: 'center',
                              fontWeight: '400', 
                              textAlign: 'center', position: 'relative' }}>
                    <div>              
                        <h1><p style={{color: '#e0515d', height: '150px'}}>
                            <button>DAILY KARMIC NUMBER</button>
                            </p></h1>
                    </div>
                </div>
            </div>
            <div style={{backgroundColor: 'transparent', display: 'table',
                        width: '100%', tableLayout: 'fixed'}}>
                <div style={{width: '33%',display: 'table-cell', color: '#fefefe',
                              fontFamily: 'balthazar,serif',
                              fontSize: '1.8rem', justifyContent: 'center',
                              fontWeight: '400',  
                              textAlign: 'center', position: 'relative' 
                            }}>
                    <div><h1><p style={{color: '#e0515d', height: '150px'}}>
                    <button>WORK COMPATIBILITY</button>
                        </p></h1>
                    </div>
                </div>
                <div component="p" style={{display: 'table-cell', color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem', justifyContent: 'center',
                                            fontWeight: '400', width: '33%', 
                                            textAlign: 'center', position: 'relative' 
                                            }}>

                    <div><h1> <p style={{height: '150px', color: '#e0515d'}}>
                                        <button>CHINESE SIGN COMPATIBILITY
                                        </button>
                                        </p>
                    </h1>
                    </div>
                </div>
                <div style={{width: 'auto%', display: 'table-cell', color: '#fefefe',
                              fontFamily: 'balthazar,serif',
                              fontSize: '1.8rem', justifyContent: 'center',
                              fontWeight: '400', 
                              textAlign: 'center', position: 'relative' }}>
                    <div>              
                        <h1><p style={{color: '#e0515d', height: '150px'}}>
                            <button>LOVE COMPATIBILITY</button>
                            </p></h1>
                    </div>
                </div>
            </div>
        </div>
        )
    }

export default game;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/games/game.js